var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShiftEmptyTwoSlots = function SvgShiftEmptyTwoSlots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3224 -1144)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M3224 1144h18v18h-18z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ShiftEmptyTwoSlots_svg__a",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3157 540h360v3802h-360z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ShiftEmptyTwoSlots_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3157 540h360v3802h-360z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ShiftEmptyTwoSlots_svg__b",
    fill: "#F2F2F2",
    transform: "translate(3157 849)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftEmptyTwoSlots_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ShiftEmptyTwoSlots_svg__c",
    fill: "#fff",
    transform: "translate(3224 1151.62)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftEmptyTwoSlots_svg__d)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ShiftEmptyTwoSlots_svg__e",
    fill: "#A1A1A1",
    transform: "translate(3224 1151.62)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftEmptyTwoSlots_svg__g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ShiftEmptyTwoSlots_svg__f",
    fill: "#fff",
    transform: "translate(3225 1144)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftEmptyTwoSlots_svg__g)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ShiftEmptyTwoSlots_svg__h",
    fill: "#A1A1A1",
    transform: "translate(3225 1144)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftEmptyTwoSlots_svg__i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ShiftEmptyTwoSlots_svg__c",
    fill: "#fff",
    transform: "translate(3233 1151.62)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftEmptyTwoSlots_svg__i)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ShiftEmptyTwoSlots_svg__e",
    fill: "#A1A1A1",
    transform: "translate(3233 1151.62)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ShiftEmptyTwoSlots_svg__j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ShiftEmptyTwoSlots_svg__f",
    fill: "#fff",
    transform: "translate(3234 1144)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ShiftEmptyTwoSlots_svg__j)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ShiftEmptyTwoSlots_svg__h",
    fill: "#A1A1A1",
    transform: "translate(3234 1144)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ShiftEmptyTwoSlots_svg__b",
    d: "M0 0h360v3378H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ShiftEmptyTwoSlots_svg__c",
    d: "M9 10.375v-8.5c-1.667-2.5-7-2.5-9 0v8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ShiftEmptyTwoSlots_svg__e",
    d: "M9 1.875h2v-.606l-.336-.504zm0 8.5v2h2v-2zm-9 0h-2v2h2zm0-8.5L-1.56.625-2 1.174v.701zm7 0v8.5h4v-8.5zm2 6.5H0v4h9zm-9 2h2v-8.5h-4v8.5zM10.664.765C9.303-1.276 6.741-2 4.625-2 2.477-2-.049-1.266-1.561.626l3.123 2.498C2.05 2.516 3.19 2 4.625 2c1.467 0 2.406.526 2.712.985z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ShiftEmptyTwoSlots_svg__f",
    d: "M7 3.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ShiftEmptyTwoSlots_svg__h",
    d: "M5 3.5A1.5 1.5 0 0 1 3.5 5v4A5.5 5.5 0 0 0 9 3.5zM3.5 5A1.5 1.5 0 0 1 2 3.5h-4A5.5 5.5 0 0 0 3.5 9zM2 3.5A1.5 1.5 0 0 1 3.5 2v-4A5.5 5.5 0 0 0-2 3.5zM3.5 2A1.5 1.5 0 0 1 5 3.5h4A5.5 5.5 0 0 0 3.5-2z"
  }))));
};
export default SvgShiftEmptyTwoSlots;